import { defineComponent as _defineComponent } from 'vue'
import TLabel from '../atoms/t-label.vue';
interface Props {
  id: string;
  label: string;
  count: number;
  checked: boolean;
  hasChildren?: boolean;
  showCount?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilterLabel',
  props: {
    id: null,
    label: null,
    count: null,
    checked: { type: Boolean },
    hasChildren: { type: Boolean, default: false },
    showCount: { type: Boolean, default: true }
  },
  emits: ['filterClick'],
  setup(__props: any, { emit }) {

const props = __props as { id: string, label: string, count: number, checked: boolean, hasChildren: boolean, showCount: boolean };




/**
 * If the label has filters below it we need to make sure the
 * accordion event doesn't fire twice.
 */
const labelClick = (e: Event) => {
  if (props.hasChildren) {
    e.preventDefault();
    emit('filterClick');
  }
};

return { __sfc: true,props, emit, labelClick, TLabel }
}

})